import service from "../services/EmailAuthenticationService";

class EmailAuthenticationApi {

    sendVerifyEmail (userId, email) {
        const request = {
            VirtualUserId: userId,
            Email: email
        };

        return new Promise((resolve, reject) => {
            service.sendVerifyEmail(request)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    sendEmailOnUpgradeToVirtualUser (email) {
        return new Promise((resolve, reject) => {
            service.sendEmailOnUpgradeToVirtualUser(email)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    loginByEmail (email) {
        return new Promise((resolve, reject) => {
            service.startLogin(email)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    loginByEmailForVirtualUserUpgrade (email) {
        return new Promise((resolve, reject) => {
            service.startUpgradeToVirtualUser(email)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    setPassword (ticket, pin, password) {
        return new Promise((resolve, reject) => {
            service.setPassword(ticket, pin, password)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    resetPassword (ticket, password) {
        return new Promise((resolve, reject) => {
            service.resetPassword(ticket, password)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    upgradeToVirtualUser (ticket, password) {
        return new Promise((resolve, reject) => {
            service.upgradeToVirtualUser(ticket, password)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    linkToVirtualUser (email, password) {
        return new Promise((resolve, reject) => {
            service.linkToVirtualUser(email, password)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    validateUserTicket (ticket, type) {
        return new Promise((resolve, reject) => {
            service.validateUserTicket(ticket, type)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    validateVirtualUserTicket (ticket, type) {
        return new Promise((resolve, reject) => {
            service.validateVirtualUserTicket(ticket, type)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    completeEmailLogin (email, password, productCode, returnUrl) {
        const request = {
            Email: email,
            Password: password,
            ProductCode: productCode,
            ReturnUrl: returnUrl
        };
        return new Promise((resolve, reject) => {
            service.completeEmailLogin(request)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    sendResetPasswordLink (email) {
        const request = {
            Email: email
        };
        return new Promise((resolve, reject) => {
            service.sendResetPasswordLink(request)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    getTicketExpirationPeriod (isVirtualUser, ticketType) {
        return new Promise((resolve, reject) => {
            service.getTicketExpirationPeriod(isVirtualUser, ticketType)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    setEmail (ticket) {
        return new Promise((resolve, reject) => {
            service.setEmail(ticket)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    validatePin (pin, ticket) {
        return new Promise((resolve, reject) => {
            service.validatePin(pin, ticket)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }
}

export default new EmailAuthenticationApi();

